import React, { FC, PropsWithChildren } from 'react'

import * as SC from './styled'

export type ContentBoxProps = PropsWithChildren<{
  className?: string
  withBottomBorder?: boolean
}>

const ContentBox: FC<ContentBoxProps> = (props) => {
  const { className, withBottomBorder, children } = props

  return (
    <SC.Container className={className} $withBottomBorder={withBottomBorder}>
      {children}
    </SC.Container>
  )
}

export default ContentBox
